<template>
  <div class="search">
    <el-form :inline="true" :disabled="loading" label-width="82px">
      <el-form-item label="日期范围：">
        <el-date-picker
          v-model="range"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:260px;margin-left:5px;"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="goSearch">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>

      <!-- <div style="float:right">
        <el-button
          type="text"
          style="margin-right:1rem;display:inline-block;"
          @click="exportExcel"
        >
          导出Excel
        </el-button>
      </div> -->
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean
  },
  data() {
    return {
      range: []
    }
  },
  mounted() {
    this.goSearch()
  },
  methods: {
    resetSearch() {
      this.range = []
    },
    goSearch() {
      let [b, e] = this.range
      if (!this.loading) {
        this.$emit('date-change', b, e)
      }
    },
    exportExcel() {
      this.$emit('export-excel')
    }
  }
}
</script>

<style lang="css" scoped>
.search {
  background-color: #fff;
  padding: 18px 20px;
  padding-bottom: 0;
  border-bottom: 1px dashed #ebeef5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
